export const MARGIN_SIZE = 48
export const MARGIN_SIZE_SM_DOWN = MARGIN_SIZE * .5
export const SMALL_DOWN_MEDIA_QUERY = "@media (max-width: 888px)"
export const XS_DOWN_MEDIA_QUERY = "@media (max-width: 640px)"
export const MAIN_CONTENT_MAX_WIDTH = 648
export const MAIN_CONTENT_MIN_WIDTH = 480